export default __webpack_public_path__ + "static/myregistry-bbc5e1c352676921da30b28fd9495eab.png";